var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.contentValue, function (templatePerm, templateIndex) {
        return _c(
          "div",
          {
            key: "special-with-template-perm-" + templateIndex,
            staticClass: "special-with-building-list",
          },
          [
            _c(
              "div",
              { staticClass: "list-title title-with-building small-4" },
              [
                _c("div", { staticClass: "list-title-label small-6" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(templateIndex === 0 ? _vm.index : "") +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _vm.isEdit
                  ? _c("HKLSelect", {
                      staticClass: "wp-template-selection",
                      attrs: {
                        value: templatePerm.template || "",
                        options: _vm.filteredTemplates(templateIndex),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleTemplateChange(templateIndex, $event)
                        },
                      },
                    })
                  : _c("div", [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            templatePerm.template
                              ? _vm.$t(
                                  "emailTemplate." +
                                    _vm.templateModule +
                                    "." +
                                    templatePerm.template
                                )
                              : ""
                          ) +
                          "\n      "
                      ),
                    ]),
              ],
              1
            ),
            _vm._v(" "),
            _vm.isEdit
              ? _c("HKLMultiSelect", {
                  key: "entitlement-select-" + templateIndex,
                  staticClass: "small-7",
                  attrs: {
                    options: _vm.entitlements,
                    value: _vm.getEntitlementSelections(templatePerm),
                  },
                  on: {
                    change: function ($event) {
                      return _vm.handleEntitlementChange(templateIndex, $event)
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isEdit
              ? _c("div", { staticClass: "small-1" }, [
                  _vm.contentValue.length
                    ? _c(
                        "div",
                        {
                          staticClass: "remove-btn",
                          on: {
                            click: function () {
                              return _vm.onDelete(templateIndex)
                            },
                          },
                        },
                        [_c("i", { staticClass: "fa fa-times fa-lg" })]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.isEdit
              ? _c("p", { staticClass: "content-value" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.formatPermStr(templatePerm)) +
                      "\n    "
                  ),
                ])
              : _vm._e(),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("div", { staticClass: "list-title title-with-building small-4" }),
          _vm._v(" "),
          _vm.isEdit
            ? _c("HKLButton", {
                staticClass: "add-btn",
                attrs: { action: "addPlus" },
                on: {
                  click: function () {
                    return _vm.onAdd()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }